module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('picture', {
    staticClass: "pic",
    style: (_vm.rootStyle)
  }, [_c('source', {
    attrs: {
      "type": "image/webp",
      "srcset": _vm.srcImg
    }
  }), _c('img', {
    staticClass: "pic__img",
    class: {
      pic__img_nosize: !_vm.image
    },
    style: ({
      height: _vm.imageHeight,
      width: _vm.imageWidth
    }),
    attrs: {
      "src": _vm.srcImg,
      "alt": _vm.alt,
      "loading": "lazy"
    },
    on: {
      "error": _vm.setErrImg
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-83c7c3ec","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppPicture/AppPicture.vue
// module id = 9a1debe3b813cd3e9470
// module chunks = 89